module.exports = __webpack_public_path__ + "static/media/thunderstorm.ddd4a018.gif";